/* Heading button */
const headingButtonSections = document.querySelectorAll('[data-header-button]');

headingButtonSections.forEach((section) => {
    const button = section.querySelector('.Button');

    console.log(section.dataset.buttonTarget);

    if(section.dataset.buttonTarget){
        section.appendChild(button);
    }
    else{
        const target = section.querySelector('[data-button-target]');
        target.appendChild(button);
    }
});

/**
 * Callers
 */
window.addEventListener("resize", allAligns);
window.addEventListener("DOMContentLoaded", allAligns);
window.addEventListener("global:align", allAligns);

/**
 * Align functions
 */
function allAligns(){
    alignProductGrid();
    alignCartItems();
    alignSliderTitles();
}

function alignProductGrid(){
    /**
     * Align targets
     */
    const productGrids = document.querySelectorAll('.Products_Grid, .Collection_Grid, .Related_Products');


    // clean style before align
    productGrids.forEach((grid) => {
        const products = grid.querySelectorAll('.Products_Grid_Elem, .Collection_Product, .Related_Product');
        products.forEach((product) => {
            product.querySelector(".Title").style.height = '';
        });
    });

    productGrids.forEach((grid) => {

        const products = grid.querySelectorAll('.Products_Grid_Elem, .Collection_Product, .Related_Product');
    
        let map = {};
    
        // Group products by y position
        products.forEach((product) => {
            const rect = product.getBoundingClientRect();
            const y = rect.top;
            if (!(y in map)) {
                map[y] = [];
            }
            map[y].push(product);
        });
    
        // Iterate over each group and align products
        for (const y in map) {
            const group = map[y];
            let maxHeight = 0;
            group.forEach((product) => {
                if(!product.classList.contains('Products_Grid_Header')){
                    const rect = product.querySelector(".Title").getBoundingClientRect();
                    if (rect.height > maxHeight) {
                        maxHeight = rect.height;
                    }
                }
            });
            group.forEach((product) => {
                if(!product.classList.contains('Products_Grid_Header')){
                    product.querySelector(".Title").style.height = `${maxHeight}px`;
                }
            });
        }
    });
}

function alignCartItems(){
    const padding = 20;

    const cartDrawer = document.querySelector('#Cart_Drawer');
    if(!cartDrawer) return;

    const cartFooter = cartDrawer.querySelector('.Cart_Drawer_Footer');

    if(!cartFooter) return;

    const cartHeader = cartDrawer.querySelector('.Cart_Drawer_Header');

    // limit height of cart items to remaining space in the cart drawer
    const cartFooterRect = cartFooter.getBoundingClientRect();
    const cartHeaderRect = cartHeader.getBoundingClientRect();
    const cartDrawerRect = cartDrawer.getBoundingClientRect();

    const cartFooterStyles = window.getComputedStyle(cartFooter);
    const cartHeaderStyles = window.getComputedStyle(cartHeader);

    const cartFooterMargin = parseFloat(cartFooterStyles.marginTop) + parseFloat(cartFooterStyles.marginBottom);
    const cartHeaderMargin = parseFloat(cartHeaderStyles.marginTop) + parseFloat(cartHeaderStyles.marginBottom);

    const remainingHeight = cartDrawerRect.height - cartHeaderRect.height - cartFooterRect.height - cartFooterMargin - cartHeaderMargin - padding;

    const cartDrawerStyles = window.getComputedStyle(cartDrawer);
    const cartDrawerPaddingTop = parseFloat(cartDrawerStyles.paddingTop);
    const cartDrawerPaddingBottom = parseFloat(cartDrawerStyles.paddingBottom);

    const totalPadding = cartDrawerPaddingTop + cartDrawerPaddingBottom;

    const adjustedHeight = remainingHeight - totalPadding;

    // set max height property on cart drawer
    cartDrawer.setAttribute('style', `--max-height: ${adjustedHeight}px`);
}

function alignSliderTitles(){
    if(window.innerWidth < 1024) return;
    const sliders = document.querySelectorAll('.About_Slider_Inner');

    sliders.forEach((slider) => {
        // Align all slides titles by adding padding to the top of title
        const slides = slider.querySelectorAll('.Slide_Header');
        let max = 0;
        slides.forEach((slide) => {
            const rect = slide.getBoundingClientRect();
            if(rect.height > max){
                max = rect.height;
            }
        });
        slides.forEach((slide) => {
            const currentHeight = slide.getBoundingClientRect().height;
            const paddingTop = max - currentHeight;
            slide.style.paddingTop = `${paddingTop}px`;
        });
    });
}